import { Pause, Play, Trash2, Loader2, History } from "lucide-react";
import { ConnectorSyncStatus } from "../../../services/spreadsheet-connector.service";

export interface ConnectorActionItem {
  _id: string;
  sync_status: ConnectorSyncStatus;
  spreadsheet_name: string;
}

interface ConnectorRowActionsProps {
  connector: ConnectorActionItem;
  onPause: (id: string) => void;
  onResume: (id: string) => void;
  onDelete: (connector: ConnectorActionItem) => void;
  onHistory: (connector: ConnectorActionItem) => void;
  isActionLoading: boolean;  // pause or resume in-flight
  isDeleteLoading: boolean;  // delete in-flight
}

export default function ConnectorRowActions({
  connector,
  onPause,
  onResume,
  onDelete,
  onHistory,
  isActionLoading,
  isDeleteLoading,
}: ConnectorRowActionsProps) {
  const canResume =
    connector.sync_status === ConnectorSyncStatus.PAUSED ||
    connector.sync_status === ConnectorSyncStatus.ERROR;

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={() => onHistory(connector)}
        disabled={isActionLoading || isDeleteLoading}
        title="Sync History"
        className="p-1.5 rounded-md text-gray-500 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        <History className="w-4 h-4" />
      </button>
      {canResume ? (
        <button
          onClick={() => onResume(connector._id)}
          disabled={isActionLoading || isDeleteLoading}
          title="Resume"
          className="p-1.5 rounded-md text-green-600 hover:bg-green-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isActionLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Play className="w-4 h-4" />}
        </button>
      ) : (
        <button
          onClick={() => onPause(connector._id)}
          disabled={isActionLoading || isDeleteLoading}
          title="Pause"
          className="p-1.5 rounded-md text-yellow-600 hover:bg-yellow-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isActionLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Pause className="w-4 h-4" />}
        </button>
      )}
      <button
        onClick={() => onDelete(connector)}
        disabled={isDeleteLoading || isActionLoading}
        title="Delete"
        className="p-1.5 rounded-md text-red-500 hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        {isDeleteLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />}
      </button>
    </div>
  );
}
